import React, { Component } from "react";
import BrandingService from "../BrandingService";
import { BrandingContext } from "./BrandingContext";
import StylingProvider from "./StylingProvider";
import FallBackPage from "../../routes/pages/fallBackPage/FallBackPage";

class BrandingProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: { isDefault: true },
      isLoading: true,
    };
  }

  componentDidMount() {
    BrandingService.get().then((result) => {
      this.setState(
        {
          config: result[0],
          isLoading: false,
        },
        () => {
          this.setBodyFonts();
          this.changeFavicon(this.state?.config?.assets?.favIcon);
        }
      );
    });
  }

  setBodyFonts() {
    var fonts = document.createElement("style");
    fonts.appendChild(document.createTextNode(this.state.config.fonts));
    document.head.appendChild(fonts);
  }

  changeFavicon(src) {
    var link = document.createElement("link");
    link.id = "dynamic-favicon";
    link.rel = "shortcut icon";
    link.href = src;
    document.head.appendChild(link);
  }

  renderLoading() {
    return <FallBackPage />;
  }

  render() {
    const { children } = this.props;
    const { isLoading, config } = this.state;
    if (isLoading) {
      return this.renderLoading();
    }
    return (
      <BrandingContext.Provider value={this.state}>
        <StylingProvider stylingVariables={config.theme}>
          {children}
        </StylingProvider>
      </BrandingContext.Provider>
    );
  }
}

export default BrandingProvider;
